<template>
  <reestr-layout>
    <fetch-json :url="urlIsogdSection" @json-loaded="triggerScroll">
      <template slot-scope="{ json: gisogdSec }">
        <div class="columns reestr-panel" v-if="gisogdSec">
          <div class="column">
            <div class="container">
              <h4 class="title is-4">{{ gisogdSec.name }}</h4>
              <GisogdDocGroups
                :project-schema="projectSchema"
                :section-id="gisogdSection"
                :opened-group-keys="openedGroupKeys"
                @change-opened-groups="changeOpenedGroups"
              ></GisogdDocGroups>
            </div>
          </div>
        </div>
      </template>
    </fetch-json>
  </reestr-layout>
</template>
<script>
import ReestrLayout from "./ReestrLayout";
import GisogdDocGroups from "../components/documents/GisogdDocGroups";
export default {
  props: {
    projectSchema: {
      type: String,
      required: true,
    },
    gisogdSection: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      openedGroupKeys: [],
    };
  },
  components: {
    ReestrLayout,
    GisogdDocGroups,
  },
  computed: {
    urlIsogdSection() {
      return `gisogdsections/${this.projectSchema}/${this.gisogdSection}`;
    },
  },
  methods: {
    changeOpenedGroups(groupKeys) {
      this.openedGroupKeys = groupKeys;
      if (groupKeys.length === 0)
        window.history.replaceState(history.state, null, location.pathname);
      else {
        this.openedGroupKeys = groupKeys;
        let params = new URL(document.location).searchParams;
        params.set("groups", groupKeys);
        window.history.replaceState(
          history.state,
          "",
          `${location.pathname}?groups=${params.get("groups")}`
        );
      }
    },
    async triggerScroll() {
      await this.$nextTick();
      this.$root.$emit("triggerScroll");
    },
  },
  created() {
    if (this.$route.query.groups) {
      let params = new URL(document.location).searchParams;
      this.openedGroupKeys = params.get("groups").split(",");
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/sass/main.scss";

h4.title {
  @include mobile {
    padding-left: 1rem;
  }
}
</style>